import { useEffect, useState } from 'react';

import getUser from "../services/decodeJWT"

import { jwtDecode } from 'jwt-decode';
import { Link } from 'react-router-dom';

const Landing = () => {
    const currentUser = getUser();

    const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        const authToken = localStorage.getItem("token");
        if (authToken) {
            const { exp } = jwtDecode(authToken);
            const currentTime = Math.floor(Date.now() / 1000)
            if (exp <= currentTime) {
                localStorage.removeItem("token");
            }
        }
    }, []);


    useEffect(() => {
        localStorage.getItem("token") && setLoggedIn(true)
    }, [localStorage])

    const FeatureCard = ({ imageSrc, badgeText, title, link }) => (
        <div className="col-xl-4 col-lg-4 col-sm-6 col-11">
            <Link to={link} className={`d-block text-center ${badgeText ? "position-relative" : ""}`}>
                {(badgeText && (
                    <div className="position-relative">
                        <div className={`badge bg-primary position-absolute end-0 bottom-0 m-3 py-2 px-2 fs-8 rounded-pill`}>
                            {badgeText}
                        </div>
                        <img className="rounded-3 border border-2 border-primary border-opacity-25 w-100" src={imageSrc} alt="" />
                    </div>
                )) || (
                        <img className="rounded-3 border border-2 border-primary border-opacity-25 w-100" src={imageSrc} alt="" />
                    )}
                <h3 className="mt-3">{title}</h3>
            </Link>
        </div>
    );

    return (
        <div className="tyn-root landing">
            <nav className="tyn-appbar">
                <div className="container px-3">
                    <div className="tyn-appbar-wrap">
                        <div className="tyn-appbar-logo ps-0 pe-3">
                            <div className="d-none d-lg-flex ">
                                <Link className="tyn-logo" to="/">
                                    <img src="/images/logo/bardo-icon.png" alt="Bardo logo" className='logo-icon' />
                                    <img src="/images/logo/bardo-text.png" alt="Bardo logo" className='logo-text' />
                                </Link>
                            </div>
                            <div className="d-lg-none d-flex">
                                <Link className="tyn-logo" to="/">
                                    <img src="/images/logo/bardo-icon.png" alt="Bardo logo" className='logo-icon' />
                                </Link>
                            </div>
                        </div>
                        <div className="tyn-appbar-content justify-content-end">
                            <div className="d-flex align-items-center">
                                <Link to="/sign-up" className="btn btn-primary try-now me-3">
                                    <span>Try Now</span>
                                </Link>
                                {loggedIn && <><span className="text-muted small text-small d-flex flex-column">Hi,{" "}
                                    {(currentUser?.username && currentUser?.username.includes('@'))
                                        ? currentUser?.username.split('@')[0].charAt(0).toUpperCase() + currentUser?.username.split('@')[0].slice(1)
                                        : (currentUser?.username || "Your Name").charAt(0).toUpperCase() + (currentUser?.username || "Your Name").slice(1)
                                    }!
                                    <Link to="/login" className="link link-primary">See your dashboard.</Link>
                                </span></> ||
                                    <span className="text-muted small text-small d-flex flex-column">OR Already registered?{" "}
                                        <Link to="/login" className="link link-primary">Login Here.</Link>
                                    </span>}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <div className="tyn-content tyn-content-page bg-white">
                <div className="tyn-hero">
                    <div className="container py-lg-3">
                        <div className="row gy-5 gx-gs justify-content-center justify-content-lg-between align-items-center flex-lg-row-reverse">
                            <div className="col-xl-5 col-lg-5 col-md-7">
                                <div className="ms-xl-n4">
                                    <img className="w-100" src="/images/landing/cover-01.png" alt="" />
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-7 col-md-9">
                                <div className="pe-lg-4 pe-xl-5 text-center text-lg-start">
                                    <h1 className="display-6 mb-2 d-md-none"><span className="text-primary">Bardo Platform</span> <span className="text-dark">AI Memories</span></h1>
                                    <h1 className="display-4 mb-2 d-none d-md-block"><span className="text-primary">Bardo Platform</span> <br /> <span className="text-dark">AI Memories</span></h1>
                                    <p>Preserve and relive memories through AI-powered digital clones, family trees, and memory capsules. Interact with your loved ones’ digital representations through advanced AI.</p>
                                    <ul className="tyn-list-inline gap gap-4 mt-4 align-items-center justify-content-center justify-content-lg-start">
                                        <li>
                                            <Link to="/sign-up" className="btn btn-primary gap-0">
                                                <span >Discover More</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tyn-main bg-opacity-50">
                    <div className="tyn-section tyn-section-lg" id="demo-pages">
                        <div className="container">
                            <div className="tyn-section-head">
                                <div className="row justify-content-center text-center">
                                    <div className="col-xl-5 col-lg-6 col-md-8 col-sm-11">
                                        <h2 className="h1 text-white">Explore <span>Bardo Features</span></h2>
                                        <p className='text-white'>Take a closer look at our carefully designed pages to experience AI-powered interactions with digital clones.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tyn-section-content">
                                <div className="row gy-4 gy-lg-5 justify-content-center">
                                    <FeatureCard
                                        imageSrc="/images/landing/screens00/register.png"
                                        title="Family Tree"
                                        link="/"
                                    />
                                    <FeatureCard
                                        imageSrc="/images/landing/screens00/cloneProfile.png"
                                        title="Family Tree"
                                        link="/"
                                    />
                                    <FeatureCard
                                        imageSrc="/images/landing/screens00/chat.png"
                                        title="AI Interaction"
                                        // badgeText="New &nbsp; v 1 . 1"
                                        link="/"
                                    />
                                    <FeatureCard
                                        imageSrc="/images/landing/screens00/chatVC.png"
                                        title="Interactive Memories"
                                        // badgeText="Hot v 1 . 2"
                                        link="/"
                                    />
                                    <FeatureCard
                                        imageSrc="/images/landing/screens00/familyTree.png"
                                        title="Milestones and Memory Capsules"
                                        // badgeText="New v 1 . 2"
                                        link="/"
                                    />
                                    <FeatureCard
                                        imageSrc="/images/landing/screens00/dashboard.png"
                                        title="Family Tree"
                                        link="/"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tyn-section bg-darker position-relative">
                        <div className="position-absolute text-center top-0 bottom-0 start-0 end-0 overflow-hidden">
                            <img className="position-absolute bottom-0 start-50 translate-middle-x" src="/images/landing/bannerBottom.png" alt="" />
                        </div>
                        <div className="container py-sm-2 position-relative">
                            <div className="tyn-section-content">
                                <div className="row justify-content-center">
                                    <div className="col-xxl-4 col-lg-5 col-md-7 col-sm-9">
                                        <div className="text-center text-light">
                                            <h2 className="text-white">Turn Your Idea into Reality</h2>
                                            <p>Join Bardo to preserve the digital legacy of your loved ones and keep their memories alive.</p>
                                            <Link to="/sign-up" className="btn btn-secondary">
                                                Try Bardo
                                            </Link>
                                            <p className="text-white small mt-3 mb-0">Free Lifetime Updates</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tyn-footer">
                    <div className="bg-white text-center py-3">
                        <p className="mb-0 small">2024 &copy; Bardo. Crafted By <a href={'https://bringer.agency'} target="_blank" rel="noopener noreferrer" className="fw-semibold" style={{ color: "#112337" }}>Bringer.Agency</a> </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Landing;
